import { S1BufferContent } from "./S1BufferContent.enum";

export class S1Buffer {
    contentType: S1BufferContent;
    data: any; //byte[]
}